module.exports = __webpack_public_path__ + "img/f-logo.f3e30a49.png";